export function  changeData_long(data, p_c) {
    var result = [],
      temp;
    for (var i in data) {
      if (data[i].p_code == p_c) {
        var obj = data[i];
        temp = changeData_long(data, data[i].id);
        if (temp.length > 0) {
          obj.children = temp;
        }
        result.push(obj);
      }
    }
    // console.log(result)
    return result;
  }
  export function getNodeCode(data,arr){
    if(data.c){
        if(arr.indexOf(data.c)==-1){
          arr.push(data.c)
        }  
    }
    if(data.children){
      if(data.children.c){
        getNodeCode(data.children,arr)
      }
      for(let i in data.children){
          getNodeCode(data.children[i],arr)
      }
    }
    return arr.join(',')
  }

  ///////////2222222222222'==='||'
  // export function getNodeCode(data,arr){
  //   if(data.subject_node){
  //     let temp=[]
  //     for(let i in data.subject_node){
  //       temp.push(i)
  //     }
  //     temp.sort()
  //     for(let j in temp){
  //         arr.push(temp[j])
  //     }
  //     arr.push('||')
  //   }
  //   if(data.children){
  //     if(data.children.subject_node){
  //       getNodeCode(data.children,arr)
  //     }
  //     for(let i in data.children){
  //         getNodeCode(data.children[i],arr)
  //     }
  //   }
  //   // return arr.sort().join(',')
  //   return arr
  // }


  /////111111111
  export function getNodeCode_topic(data,arr){
    if(data.subject_node){
      for(let i in data.subject_node){
        if(arr.indexOf(i)==-1){
          arr.push(i)
        }
      }
    }
    if(data.children){
      if(data.children.subject_node){
        getNodeCode_topic(data.children,arr)
      }
      for(let i in data.children){
        getNodeCode_topic(data.children[i],arr)
      }
    }
    return arr.sort()
  }

  export  function timeChangetype(stringTime){
    var timestamp2 = Date.parse(new Date(stringTime));
//		timestamp2 = timestamp2;
     return timestamp2/1000;
  }

  export function unique1(arr){
    var hash=[];
    for (var i = 0; i < arr.length; i++) {
       if(hash.indexOf(arr[i])==-1){
        hash.push(arr[i]);
       }
    }
    return hash;
  }
 